import { useState, useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, IconButton, DialogContent, DialogActions, TextField, InputAdornment } from '@mui/material';
import { ArrowSquareLeft, SearchNormal} from 'iconsax-react';
import TagItem from './tag-item';

const ManageTagsModal = ({ show, setShow, uiStore, close }) => {
    const [loading, setLoading] = useState(false);
    const [tags, setTags] = useState([]);
    const [query, setQuery] = useState('');

    const confirm = async () => {
        setLoading(true);
        close();
        setLoading(false);
    };

    useEffect(() => {
        async function getTags() {
            const tags = await uiStore.getAllTags();
            console.log({tags});
            setTags(tags);
        }

        getTags();

    }, [show, uiStore]);

    const deleteTag = async (tagId) => {
        const data = await uiStore.deleteTag(tagId);
        setTags(data);
    }   

    const updateTag = async (tagId, value) => {
        const data = await uiStore.updateTag(tagId, value);
        setTags(data);
    }

    return (
        <Dialog
            open={show}
            onClose={close}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            fullWidth
            maxWidth='xs'
        >
            <DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{ ml: -2, mr: 1 }}
                >
                    <ArrowSquareLeft
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>

                Tags Management
            </DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    size='small'
                    placeholder='Search for tag'
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchNormal
                                    size="24"
                                    variant="Bulk"
                                />
                            </InputAdornment>
                        ),
                    }}
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    sx={{mb: 3}}
                />

                {tags?.filter(i => i.tag.toLowerCase().includes(query.toLowerCase()))?.map(tag =>
                    <TagItem key={tag._id} uiStore={uiStore} tag={tag} deleteTag={deleteTag} updateTag={updateTag} />
                )}

            </DialogContent>
            <DialogActions>
                <LoadingButton loading={loading} onClick={confirm} variant="contained" color="primary">
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default ManageTagsModal;